<template>
  <app-page-layout page-class="msc-app-help-page" :show-notifications="false">
    <header class="msc-app-help-intro">
      <p class="msc-app-help-intro__eyebrow">Help &amp; Resources</p>
      <h1 class="msc-app-help-intro__title">Find answers and walkthroughs</h1>
      <p class="msc-app-help-intro__subtitle">
        Quick videos, documents, and common questions for managing meals and your account.
      </p>
    </header>

    <section class="msc-app-help-section" aria-labelledby="help-docs-heading">
      <header class="msc-app-help-section__header">
        <h2 id="help-docs-heading" class="msc-app-help-section__title">Documents &amp; Videos</h2>
        <p class="msc-app-help-section__subtitle">Open a guide anytime you need a refresher</p>
      </header>

      <ul class="msc-help-resources">
        <li v-for="resource in resources" :key="resource.href">
          <a
            class="msc-help-resource"
            :href="resource.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span
              class="msc-help-resource__icon"
              :class="`msc-help-resource__icon--${resource.kind}`"
              aria-hidden="true"
            >
              <i :class="resource.icon"></i>
            </span>
            <span class="msc-help-resource__body">
              <span class="msc-help-resource__title">{{ resource.title }}</span>
              <span class="msc-help-resource__desc">{{ resource.description }}</span>
            </span>
            <span class="msc-help-resource__action" aria-hidden="true">
              <i class="now-ui-icons arrows-1_minimal-right"></i>
            </span>
          </a>
        </li>
      </ul>
    </section>

    <section class="msc-app-help-section" aria-labelledby="help-faq-heading">
      <header class="msc-app-help-section__header">
        <h2 id="help-faq-heading" class="msc-app-help-section__title">FAQ</h2>
        <p class="msc-app-help-section__subtitle">Tap a question to see the answer</p>
      </header>

      <div v-if="faqs.length === 0" class="msc-app-help-empty" role="status">
        Loading frequently asked questions…
      </div>

      <div v-else class="msc-faq-list">
        <faq-card
          v-for="(faq, index) in faqs"
          :key="faq.id || index"
          :faq="faq"
          :index="index"
        />
      </div>
    </section>
  </app-page-layout>
</template>

<script>
  import { FaqCard } from '@/components';
  import AppPageLayout from '@/layout/AppPageLayout.vue';
  import GeneralService from '@/services/GeneralService';

  export default {
    name: 'app-help-page',
    components: {
      AppPageLayout,
      FaqCard,
    },
    data() {
      return {
        faqs: [],
        // FUTURE (multi-school): resources are still St. Luke’s–oriented / hard-coded.
        // Drive docs & videos from school/tenant config or DB (see README → Future Work).
        resources: [
          {
            href: '/doc/ingredients-stlukes.pdf',
            title: 'Nutrient Listing (PDF)',
            description: 'Master nutrient listing.',
            icon: 'fa fa-file-pdf',
            kind: 'pdf',
          },
          {
            href: '/video/paymentDetails.mp4',
            title: 'Payment Registration Overview',
            description: 'How to connect your credit card to your account.',
            icon: 'fa fa-question',
            kind: 'video',
          },
          {
            href: '/video/LinkingStudent-Lindy.mp4',
            title: 'Register / Link a Student',
            description: 'How to link a student to your account.',
            icon: 'fa fa-question',
            kind: 'video',
          },
        ],
      };
    },
    async mounted() {
      await this.getFaqs();
    },
    methods: {
      async getFaqs() {
        // FUTURE (multi-school): /getFaqs content is St. Luke’s–centric today.
        // Other schools need their own Q&A from the database, scoped by tenant/school.
        // See README → Future Work / Notes.
        try {
          const response = await GeneralService.getFaqs();
          this.faqs = response.data || [];
        } catch (err) {
          this.faqs = [];
        }
      },
    },
  };
</script>
